import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { EmailService } from '../../../services/email.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, NgModel } from '@angular/forms';
import { CommonModule } from '@angular/common';

export interface EmailDialogData {
  from: string;
  to: string;
}

@Component({
  selector: 'app-email',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule
  ],
  templateUrl: './email.html',
  styleUrl: './email.scss'
})
export class Email {
  subject = '';
  text = '';

  @ViewChild('fromInput') fromInput!: NgModel;
  @ViewChild('subjectInput') subjectInput!: NgModel;
  @ViewChild('textInput') textInput!: NgModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EmailDialogData,
    private dialogRef: MatDialogRef<Email>,
    private emailService: EmailService
  ) {}

  isFormValid(): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return !!(
      this.data.from &&
      emailRegex.test(this.data.from) &&
      this.subject?.trim() &&
      this.text?.trim()
    );
  }

  send() {
    if (!this.isFormValid()) {
      // Marquer tous les champs comme touchés pour afficher les erreurs
      this.fromInput?.control.markAsTouched();
      this.subjectInput?.control.markAsTouched();
      this.textInput?.control.markAsTouched();
      return;
    }

    const body = this.data.from + ' vous a envoyé ce message via Referio :\n\n' + this.text;
    this.emailService.sendEmail({
      from: 'info@referio.be',
      to: this.data.to,
      subject: this.subject,
      text: body
    }).subscribe({
      next: () => this.dialogRef.close(true),
      error: () => alert("Erreur lors de l'envoi")
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}